import React from 'react';
import { clsx } from 'clsx';
import { PROVIDER_LABELS, type AppProvider } from '@/types/planning';

interface Props {
  provider?: AppProvider | string | null;
  size?: number;
  /** Mostra o nome ao lado do ícone ("Google" / "Microsoft"). */
  withLabel?: boolean;
  className?: string;
}

/** Logo do Google (quatro cores) em SVG, sem dependência externa. */
const GoogleMark: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false">
    <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h12.7c-.6 3-2.2 5.5-4.7 7.2l7.6 5.9c4.4-4.1 6.9-10.1 6.9-17.1z" />
    <path fill="#FBBC05" d="M10.5 28.6c-.5-1.4-.8-3-.8-4.6s.3-3.2.8-4.6l-7.9-6.1C.9 16.6 0 20.2 0 24s.9 7.4 2.6 10.7l7.9-6.1z" />
    <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.6-5.9c-2.1 1.4-4.8 2.3-8 2.3-6.3 0-11.6-4.1-13.5-9.9l-7.9 6.1C6.5 42.6 14.6 48 24 48z" />
  </svg>
);

/** Logo da Microsoft (quatro quadrados) em SVG. */
const MicrosoftMark: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 23 23" aria-hidden="true" focusable="false">
    <rect x="1" y="1" width="10" height="10" fill="#F25022" />
    <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
    <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
    <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
  </svg>
);

/** Ícone pequeno do provedor de identidade (Google / Microsoft), com `title` acessível. */
export const ProviderIcon: React.FC<Props> = ({ provider, size = 14, withLabel = false, className }) => {
  if (provider !== 'google' && provider !== 'entra') return null;
  const label = PROVIDER_LABELS[provider];
  return (
    <span className={clsx('inline-flex items-center gap-1 align-middle', className)} title={`Entrou com ${label}`}>
      {provider === 'google' ? <GoogleMark size={size} /> : <MicrosoftMark size={size} />}
      {withLabel && <span>{label}</span>}
      {!withLabel && <span className="sr-only">{label}</span>}
    </span>
  );
};

export default ProviderIcon;
